import { Injectable } from '@angular/core';
import { ExternalApiBaseService } from './external-api-base.service';

@Injectable()
export class ExternalApiService extends ExternalApiBaseService {

}
